import { InfoOutlined } from '@mui/icons-material';

import {
  DisclaimerContainer,
  DisclaimerHeaderRow,
  DisclaimerIcon,
  DisclaimerText,
} from './components';

export const CourtCaseDisclaimer = () => {
  return (
    <DisclaimerContainer>
      <DisclaimerHeaderRow>
        <DisclaimerIcon>
          <InfoOutlined />
        </DisclaimerIcon>
        <DisclaimerText
          variant="body2"
          sx={{ fontWeight: 700, fontStyle: 'normal' }}
        >
          PLEASE BE ADVISED:
        </DisclaimerText>
      </DisclaimerHeaderRow>
      <DisclaimerText variant="body2">
        Court case information contained in our reports may not always be 100%
        up-to-date, accurate or complete, since data is pulled from records
        maintained by various state, county, municipal and other government
        agencies and their contents may not be fully digitized, updated or
        comprehensive. Please use our results as no more than a point of
        departure and certainly no substitute for your own due diligence.
      </DisclaimerText>
    </DisclaimerContainer>
  );
};
